import React from 'react';
import { CalendarX, LogOut } from 'lucide-react';
import { AppointmentCard } from './AppointmentCard';

export const AppointmentsList = ({
  appointments,
  onCancelAppointment,
  cancellingId,
  loading,
  customer,
  businessLogo,
  businessName,
  onDisconnect,
  onBookNewAppointment
}) => {
  return (
    <div className="min-h-screen bg-white relative">
      <div className="max-w-md mx-auto pt-8 pb-32 px-4">
        {/* Header with disconnect button */}
        <div className="flex items-center justify-between mb-6">
          <button
            onClick={onDisconnect}
            className="flex items-center gap-2 text-red-600 hover:text-rose-500 transition-colors"
            title="התנתק"
          >
            <LogOut className="w-5 h-5" />
            <span className="text-xs font-medium">התנתק</span>
          </button>

          <h1 className="text-2xl font-bold text-gray-900 text-center flex-1">
            {businessName ? (
              <>
                התורים שלי - <span className="font-bold">{businessName}</span>
              </>
            ) : (
              'התורים שלי'
            )}
          </h1>

          {/* Spacer for symmetry */}
          <div className="w-20"></div>
        </div>

        {/* Content */}
        {loading ? (
          <div className="text-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-rose-500 mx-auto"></div>
            <p className="text-gray-600 mt-2">טוען תורים...</p>
          </div>
        ) : appointments.length > 0 ? (
          <div className="space-y-4 mb-8">
            {appointments.map((appointment) => (
              <AppointmentCard
                key={appointment.id}
                appointment={appointment}
                onCancel={onCancelAppointment}
                isCancelling={cancellingId === appointment.id}
              />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-12 px-6">
            {/* Icon */}
            <div className="w-20 h-20 bg-gradient-to-br from-rose-100 to-pink-100 rounded-full flex items-center justify-center mb-6">
              <CalendarX className="w-10 h-10 text-rose-400" />
            </div>

            {/* Title */}
            <h2 className="text-xl font-semibold text-gray-900 mb-3 text-center">
              אין תורים קרובים
            </h2>

            {/* Description */}
            <p className="text-gray-600 text-center mb-2 leading-relaxed">
              נראה שאין לך תורים מתוזמנים כרגע.
            </p>
            <p className="text-gray-500 text-center text-sm leading-relaxed">
              זה הזמן לקבוע תור חדש ולהתפנק!
              <br />
              לחץ על הכפתור למטה כדי לבחור את השירות והזמן המועדפים עליך.
            </p>
          </div>
        )}

        {/* Business Logo */}
        {businessLogo && (
          <div className="w-full py-6 flex justify-center">
            <img
              src={businessLogo}
              alt="Business Logo"
              className="h-16 w-auto object-contain"
            />
          </div>
        )}
      </div>

      {/* Fixed Button at Bottom */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg">
        <div className="max-w-md mx-auto px-6 py-4">
          <button
            onClick={onBookNewAppointment}
            className="w-full bg-gradient-to-r from-rose-500 to-pink-500 text-white py-4 rounded-2xl font-semibold hover:shadow-lg transition-all duration-300"
          >
            קבע תור חדש
          </button>
        </div>
      </div>
    </div>
  );
};
